import { render } from "./ShootingPinControls.vue?vue&type=template&id=0dfe6558&scoped=true&ts=true"
import script from "./ShootingPinControls.vue?vue&type=script&lang=ts"
export * from "./ShootingPinControls.vue?vue&type=script&lang=ts"

import "./ShootingPinControls.vue?vue&type=style&index=0&id=0dfe6558&lang=scss&scoped=true"

import exportComponent from "/www/public/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dfe6558"]])

export default __exports__